import { render } from "./UserAdministrationModal.vue?vue&type=template&id=85c1f8ac&scoped=true"
import script from "./UserAdministrationModal.vue?vue&type=script&lang=js"
export * from "./UserAdministrationModal.vue?vue&type=script&lang=js"

import "./UserAdministrationModal.vue?vue&type=style&index=0&id=85c1f8ac&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85c1f8ac"]])

export default __exports__